import { render } from "./ReportDashboard.vue?vue&type=template&id=08d86d1a&scoped=true"
import script from "./ReportDashboard.vue?vue&type=script&lang=js"
export * from "./ReportDashboard.vue?vue&type=script&lang=js"

import "./ReportDashboard.vue?vue&type=style&index=0&id=08d86d1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d86d1a"]])

export default __exports__